import { useEffect, useRef } from "react";
import { styled } from "@mui/material";
import { useScroll } from "hooks/useScroll";
import ChatbotOptions from "./ChatbotOptions";
import ChatbotAnswer from "./ChatbotAnswer";
import ChatbotQuestion from "./ChatbotQuestion";
import ChatbotLoader from "./ChatbotLoader";

const MessagesWrapper = styled("div")({
  flexGrow: 1,
  overflowY: "hidden",
  "& .chat": {
    width: "100%",
    overflowY: "scroll",
    "& .chat-messages": {
      display: "flex",
      flexDirection: "column",
      "& .message": {
        "&.bot-message": {
          alignSelf: "flex-start",
        },
        "&.user-message": {
          alignSelf: "flex-end",
          borderColor: "blue",
        },
      },
    },
    "& .choices": {
      overflowY: "scroll",
      maxHeight: "290px",
    },
  },
});

const ChatbotMessagesUnstyled = ({
  isVisible,
  isLoading,
  messages,
  onSelect,
  className,
}) => {
  const chatRef = useRef(null);

  const { scrollToStart } = useScroll({ elementRef: chatRef });

  useEffect(() => {
    if (typeof scrollToStart === "function") {
      scrollToStart({ start: "bottom" });
    }
  }, [messages, scrollToStart]);

  return (
    <MessagesWrapper
      className={className}
      sx={{ display: isVisible ? "inherit" : "none" }}
    >
      <div className="chat" ref={chatRef}>
        <div className="chat-messages">
          {messages.map((msg, idx) =>
            msg.from === "user" ? (
              <ChatbotAnswer key={idx} text={msg.text} />
            ) : (
              <ChatbotQuestion key={idx} text={msg.text} />
            )
          )}
          {isLoading && <ChatbotLoader />}
        </div>
        <div className="choices">
          {!isLoading && <ChatbotOptions onClick={onSelect} />}
        </div>
      </div>
    </MessagesWrapper>
  );
};

const ChatbotMessages = styled(ChatbotMessagesUnstyled)({});

export default ChatbotMessages;
